import { render, staticRenderFns } from "./ViolationListActions.vue?vue&type=template&id=178e85c2"
import script from "./ViolationListActions.vue?vue&type=script&lang=js"
export * from "./ViolationListActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports